import React,{useEffect,useState} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Tab, Form,Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';
import { Flip, Slide, toast } from 'react-toastify';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../InputField/InputField";
import { Box,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import {List } from '@mui/icons-material';
//import "./MyOrders.styles.css";
import DataGrid,  { Column, FilterRow, HeaderFilter, SearchPanel, Sorting, ColumnChooser, Pager, FilterPanel, Button, Editing, MasterDetail, Export, RemoteOperations } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import "../ReportDetail/textbox.css"

const Reports = () => {

  const navigate = useNavigate();
  const [logedIn, setLogedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [contracts, setContracts] = useState(false);
    const [selectedContract, setSelectedContract] = useState(false);
    const [dmShow, setDmShow] = useState(false);
    const [emShow, setEmShow] = useState(false);

    const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

    const customDataSource = new CustomStore({
        load: (loadOptions) => {
            let params = '?';
      
            [
                'filter',
                'group', 
                'groupSummary',
                'parentIds',
                'requireGroupCount',
                'requireTotalCount',
                'searchExpr',
                'searchOperation',
                'searchValue',
                'select',
                'sort',
                'skip',     
                'take',
                'totalSummary', 
                'userData'
            ].forEach(function(i) {
                if(i in loadOptions && isNotEmpty(loadOptions[i])) {
                    params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                }
            });
            params += `arnum=${userDetails.arnum}`;
            //params += `${'accountid'}=${userDetails.arnum}&`;
            //params = params.slice(0, -1);
      
            return Axios.get(`/admin/ReportListing_front${params}`)
            .then(async (data) => {
                //if (catalogs.status == 200 && catalogs.data?.data?.contracts) {
                  //setContracts(catalogs.data.data.contracts);
                  // console.log(data);
                  return {
                    data:data.data.data.data,
                    totalCount: data.data.data.totalcount
                  }
                //}
            });

            /* return fetch(API_BASE_URL + `api/report/GetFormListing${params}`)
                .then(handleErrors)
                .then(response => response.json())
                .then(response => {
                    return {
                        data: response.data,
                        totalCount: response.totalCount
                    };
                })
                .catch(() => { throw 'Network error' });*/
        },
      });

    async function getContracts () {
        // userDetails.arnum="ARM-90212518";
        await Axios.get(`/account/getallreport`)
        .then(async (catalogs) => {
            if (catalogs.status == 200 && catalogs.data?.data?.contracts) {
              setContracts(catalogs.data.data.contracts);
            }
        })
    }

   

    async function addNewCatalog (values) {
        await Axios.post(`/corporate/catalog/${userDetails.arnum}`,{
          "catalog": {
            "catalogname": values.catalogname
          }
        })
        .then(async (catalogs) => {
          getContracts(userDetails.refnum);
          toast.success('New catalog added successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setEmShow(false);
        })
    }

    async function deleteCatalog () {
      if(selectedContract){
        await Axios.delete(`/corporate/catalog/${userDetails.arnum}/${selectedContract}`)
        .then(async (catalogs) => {
          getContracts(userDetails.refnum);
          toast.success('Catalog deleted successfully', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
          });
          setDmShow(false);
        })
      }
    }

    useEffect(() => {
        setLogedIn(AuthVerify.isUserLogedIn());
    }, []);

    useEffect(() => {
        if(logedIn)setUserDetails(AuthVerify.getUser());
    }, [logedIn]);

    useEffect(() => {
        if(userDetails)getContracts(userDetails.refnum);
    }, [userDetails]);


  return (
    <div className="col-main">
      <div className="my-account" class="tungstyle">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Report Analysis</h2>
        </div>
        <div className="dashboard">
          <div className="box-account" style={{ display: "grid" }}>
            <div className="page-title">
              <h2></h2>
            </div>
          </div>
          <div className="box-account" style={{ display: "grid" }}>
            
          <DataGrid id="gridContainer"
          //ref={(ref) => this.dataGrid = ref}
          dataSource={customDataSource}
          showBorders={true}
          allowColumnReordering={true}
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          columnResizingMode="widget"
          height="800">
            <RemoteOperations groupPaging={true}/>
            <Sorting mode="multiple" />
            <ColumnChooser
                    enabled={true}
                />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 100]}
                    showNavigationButtons={true}
                    showInfo={true}
                    infoText="Page #{0}. Total: {1} ({2} items)"
                />
                <FilterPanel visible={true} /> 

        <Export enabled={true} fileName={'My Orders'}/>


          <FilterRow visible={true}
            applyFilter={"auto"}
           />
          <HeaderFilter visible={false} />
          <SearchPanel visible={true}
            width={240}
            placeholder="Search..." />
          <Column dataField="refnum"
          caption="Report #"
          width={200} />
          <Column dataField="reportname"
          caption="Report Name"
          minwidth={150} />

                <Column
                    width={60}
                    //dataField="Title"
                    caption="Action"
                    cellRender={(data) =>{
                      return <Box sx={{ display: 'flex', gap: '1rem', marginTop: -0.5 }}>
                      <Tooltip arrow placement="left" title="Details">
                        <IconButton onClick={() => navigate(`/report-detail?${data.data.refnum}`)}>
                          <List/>
                        </IconButton>
                      </Tooltip>
                    </Box>;
                    }}
                />

       {/*  <Column type="buttons" width={50}>
          <Button icon="info" onClick={(e) =>{
              navigate(`/report-detail?${e.row.data.refnum}`, 
            )
          }}/>
        </Column> */}

        
        </DataGrid>


        

          </div>
          <br />
        </div>
      </div>
    </div>
  );
  
};

export default Reports;
